import React from 'react';
import PropTypes from "prop-types";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { compose } from 'recompose';
import { withRouter } from "react-router-dom";
import UserAvatar from "./UserAvatar";
import UserNotifications from './UserNotifications';

const useStyles = theme => ({
    appBar: {
        width: "100%",
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    toolbarContainer: {
        transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    userDetails: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "center"
    },
    toolbarContent: {
        display: "flex",
        justifyContent: "space-between",
    }
});

const TopBar = (props) => {
    const { classes, title } = props;

    return (
        <AppBar color="inherit"
            position="static"
            className={classes.appBar}>
            <Toolbar className={classes.toolbarContent}>
                <div className={classes.toolbarContainer}>
                    <Typography variant="h4">
                        {title}
                    </Typography>
                </div>
                <div className={classes.userDetails}>
                    <UserNotifications />
                    <UserAvatar />
                </div>
            </Toolbar>
        </AppBar>
    );
};

export default compose(
    withRouter,
    withStyles(useStyles),
)(TopBar);

TopBar.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string
};